/**
 * Label visibility for the reorganized sidebar: always visible on mobile,
 * follows the sidebar pinned/hover state on desktop (mirrors the legacy
 * sidebar item behavior).
 */
export const getExpandedOnlyDisplay = (isPinned: boolean) =>
    ({
        display: { base: 'flex', lg: isPinned ? 'flex' : 'none' },
        opacity: { base: 1, lg: isPinned ? 1 : 0 },
        _groupHover: { display: 'flex', opacity: 1 },
    }) as const

/**
 * Ephemeral pin visibility: the `.sidebar-pin` child only shows while its row
 * is hovered or focused. Uses row-level `:hover` (not Chakra `_groupHover`,
 * which would fire on sidebar hover since the sidebar itself is a group).
 * Always visible on touch devices where hover doesn't exist.
 */
export const ephemeralPinSx = {
    '& .sidebar-pin': {
        opacity: 0,
        visibility: 'hidden' as const,
        transition: 'opacity 0.2s, visibility 0.2s',
    },
    '&:hover .sidebar-pin, &:focus-within .sidebar-pin': {
        opacity: 1,
        visibility: 'visible' as const,
    },
    '@media (hover: none)': {
        '& .sidebar-pin': {
            opacity: 1,
            visibility: 'visible' as const,
        },
    },
} as const

/**
 * Drag-handle affordance: the `.sidebar-grip` child stays subtle until its
 * row is hovered, then brightens. Row-level `:hover` for the same reason as
 * `ephemeralPinSx` (the sidebar itself is a group).
 */
export const dragHandleSx = {
    '& .sidebar-grip': {
        color: 'gray.600',
        transition: 'color 0.2s',
    },
    '&:hover .sidebar-grip': {
        color: 'gray.400',
    },
} as const
